import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Header from '../../../../../../../components/Stake/header';
import * as gamerStakeActions from '../../../../../../../actions/gamer-stake-actions-polygon';
import GamerIcon from '../../../../../../../assets/images/GAMER.png';
import Success from '../../../../../../../components/Stake/frame/success';

const WithdrawSuccess = () => {
  const dispatch = useDispatch();
  const { id } = useSelector((state) => state.GAMERPOLYGONstake.stake);

  return (
    <>
      <Header icon={GamerIcon} title={`GAMER-Withdrawal`} />
      <Success
        title='Withdrawn'
        doneClick={() => dispatch(gamerStakeActions.stakeReset())}
        txId={id}
      />
    </>
  );
};

export default WithdrawSuccess;
